<template>
    <textarea ref="redactor" :name="name" :placeholder="placeholder" :value="value" />
</template>

<script>
    import Vue from 'vue'
    import store from '../store/index'
    
    export default {
        redactor: false,
        props: {
            value: {
                default: '',
                type: String
            },
            placeholder: {
                type: String,
                default: null
            },
            name: {
                type: String,
                default: null
            },
            config: {
                default() {
                    return {}
                },
                type: Object
            }
        },
        watch: {
            value(newValue)
            {
                if (!this.redactor.editor.isFocus() && !this.redactor.editor.isSourceMode()) this.redactor.source.setCode(newValue)
            }
    },
    mounted() {
        this.init()
    },
    destroyed (){
        this.redactor.stop()
        window.$R(this.$refs.redactor, 'destroy')
        this.redactor.element.rootElement.remove()
        this.redactor = null
        this.$parent.redactor = null
    },
    methods: {
        init () {
            var me = this;
            var callbacks = {
                changed: function(html) {
                    me.handleInput(html)
                    return html
                },
                upload: {
                    error: function(response)
                    {
                        store.dispatch('messages/error', response.message)
                    }
                }
            };

            // extend config
            Vue.set(this.config, 'callbacks', callbacks);

            // call Redactor
            var app = window.$R(this.$refs.redactor, this.config);

            // set instance
            this.redactor = app;
            this.$parent.redactor = app;
        },
        handleInput (val) {
            this.$emit('input', val);
        }
    }
}
</script>